export { View as YouTube } from './view'
